import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EMPTY, fromEvent, Observable, of, Subject, timer } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  take,
  tap,
} from 'rxjs/operators';
import { GlobalService } from 'src/app/_local-storage/global.service';
import { EnvService } from 'src/app/_servicos/env.service';
import { ServidorService } from 'src/app/_servicos/servidor.service';

import { AtoPort } from '../../_classes/ato-port';
import { Documentos } from '../../_classes/documentos';
import { Filtro } from '../../_classes/filtro';
import { PublicaPort } from '../../_classes/publica-port';
import { Servidor } from '../../_classes/servidor';
import { Util } from '../../_classes/util';
import { UtilLogAcessoSistema } from '../../_classes/util-log-acesso-sistema';
import { RestService } from '../../_servicos/rest.service';
import { ModalAjudaService } from '../../shared/modal-ajuda.service';
import { ModalAlertaService } from '../../shared/modal-alerta.service';
import { Retifica } from './../../_classes/retifica';

@Component({
  selector: 'app-publicacoes-externas',
  templateUrl: './publicacoes-externas.component.html',
  styleUrls: ['./publicacoes-externas.component.scss'],
})
export class PublicacoesExternasComponent implements OnInit {
  private readonly recurso: string = 'publicacao'; //mesmo que a rota
  carregando = false;
  displayedColumns: string[] = [
    'tipoDocumento.dsTipodocumento',
    'origPort',
    'nroPort',
    'anoPort',
    'dataPort',
    'descPort',
    'acoes',
  ];

  filtroTipoDocFixo = null;
  atoPortSelecionado: AtoPort = null;

  servidor$: Observable<Servidor>;

  @ViewChild('filtroNr', { static: true }) filtroNr: ElementRef;
  @ViewChild('filtroAno', { static: true }) filtroAno: ElementRef;
  @ViewChild('filtroDesc', { static: true }) filtroDesc: ElementRef;
  @ViewChild('filtroOrig', { static: true }) filtroOrig: ElementRef;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  arquivoUrl: any;
  modalRef: BsModalRef;

  panelOpenState = true;

  total: number = 0;

  erros$ = new Subject<boolean>();
  dataSource$: Observable<AtoPort[]>;
  dataSource: MatTableDataSource<AtoPort>;
  dataSourcePP$: Observable<PublicaPort[]>;
  dataSourcePP: MatTableDataSource<PublicaPort>;
  dataSourceE$: Observable<Retifica[]>;
  dataSourceE: MatTableDataSource<Retifica>;
  listaE: Retifica[];
  listaPublicaPort: PublicaPort[];

  itensAjuda = [
    {
      titulo: 'Tipo',
      texto: 'Informa o tipo de publicação',
    },
    {
      titulo: 'Origem',
      texto: 'Localidade do Tribunal que publicou o documento',
    },
    {
      titulo: 'Nr',
      texto: 'Número do documento publicado',
    },

    {
      titulo: 'Ano',
      texto: 'Ano do documento publicado',
    },
    {
      titulo: 'Descrição',
      texto: 'Resumo informativo da publicação',
    },
  ];

  private t: any;
  private tE: any;

  config = {
    keyboard: true,
    class: 'modal-lg',
  };

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
    if (this.tE) {
      this.tE.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private alertService: ModalAlertaService,
    private ajudaService: ModalAjudaService,
    private modalService: BsModalService,
    private servService: ServidorService,
    private sanitizer: DomSanitizer,
    private router: ActivatedRoute,
    //private global: GlobalService,
    private env: EnvService
  ) {
    this.dataSource = new MatTableDataSource<AtoPort>([]);
    this.dataSource$ = of();
    this.router.params.pipe(take(1)).subscribe((qp) => {
      //console.log(qp);
      this.filtroTipoDocFixo = qp.tipo;
    });
    //console.log('Publicacoes-externas', this.router);
    //this.global.gravarUltimaRota(router.snapshot);
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      'publicacoes-externas',
      0,
      this.service
    );
  }
  /*
  verificarEfeitosSofridos(ato: AtoPort) {
    console.log('vou buscar efeitos sofridos', ato);
    if (ato) {
      this.carregando = true;

      this.service.listarEfeitos(ato, 'S').subscribe(
        (a: any) => this.executarAoCarregarDatasourceEfeitos(a),
        catchError((e) => {
          console.log('erro', e);
          this.handleError(e);
          return EMPTY;
        })
      );
    }
  }*/

  mostrar(pTemplate: TemplateRef<any>, h: AtoPort) {
    //console.log('chamei o mostrar');
    this.atoPortSelecionado = new AtoPort(h);
    this.buscar(pTemplate, h, false);
    this.carregando = true;
  }

  executarAoMostrarOuDownloadBlob(
    x: Blob,
    template: TemplateRef<any>,
    pBaixar: boolean,
    nomeDoArquivo: string
  ) {
    const blob = new Blob([Util.Base64ToBlob(x)], {
      type: 'application/pdf',
    });
    this.arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
    if (!pBaixar) {
      this.modalRef = this.modalService.show(template, this.config);
    } else {
      let newVariable: any = window.navigator;
      if (newVariable && newVariable.msSaveOrOpenBlob) {
        newVariable.msSaveOrOpenBlob(blob); //console.log('Carregando aterado2', this.carregando);
        return;
      }
      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(blob);

      let link = document.createElement('a');
      link.href = data;
      link.download = nomeDoArquivo;
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );

      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        this.carregando = false;
      }, 100);
    }
    this.carregando = false;
  }

  downloadDentroDaVisualizacao() {
    this.buscar(null, this.atoPortSelecionado, true);
  }

  verificarEfeitos(pTemplate: TemplateRef<any>, ato: AtoPort) {
    //console.log('vou verificar efeitos', ato);

    this.carregando = true;
    this.service.listarEfeitos(ato, 'T').subscribe(
      (a) => this.executarAoCarregarDatasourceEfeitos(pTemplate, a),
      catchError((e) => {
        //console.log('erro', e);
        this.handleError(e);
        return EMPTY;
      })
    );
  }

  montarTitulo(a: AtoPort): string {
    let s: AtoPort = new AtoPort(a);

    return s.getTitulo();
  }

  executarAoCarregarDatasourceEfeitos(
    pTemplate: TemplateRef<any>,
    x: Retifica[]
  ) {
    //console.log('resultado Efeitos', x);
    this.listaE = x;
    this.dataSourceE = new MatTableDataSource<Retifica>(x);
    this.modalRef = this.modalService.show(pTemplate, this.config);
    this.carregando = false;
  }

  converter(p: PublicaPort) {
    return new PublicaPort(p);
  }

  buscarPublicacoes() {
    //console.log('Vou listar as publicações');
    this.listaPublicaPort = [];
    if (this.atoPortSelecionado) {
      //console.log('entrei');
      this.carregando = true;
      this.service.listarOndePublicou(this.atoPortSelecionado.idPort).subscribe(
        (a: PublicaPort[]) => this.executarAoCarregarDatasourcePublicacoes(a),
        catchError((e) => {
          //console.log('erro', e);
          this.handleError(e);
          return EMPTY;
        })
      );
    } else {
      //console.log('this.atoioPortSelecionao é nulo');
    }
  }

  buscar(pTemplate: TemplateRef<any>, h: AtoPort, pBaixar: boolean) {
    //console.log('buscar');
    this.carregando = true;
    this.service.getPublicacaoComBlob(h.idDocumento).subscribe(
      (a: any) => {
        //console.log('getPublicacaoComBlob', a);
        let tmp: Documentos = new Documentos(a);
        this.buscarPublicacoes();
        this.executarAoMostrarOuDownloadBlob(
          tmp.documentoValido(),
          pTemplate,
          false,
          tmp.nomeArquivo()
        );
      },
      catchError((e) => {
        console.error('erro', e);
        this.handleError(e);
        return EMPTY;
      })
    );
  }

  ngOnInit() {
    //console.log('ngOnInit() publicacoes');
    this.atualizar();
    fromEvent(this.filtroNr.nativeElement, 'keyup')
      .pipe(
        // get value
        map((event: any) => {
          return event.target.value;
        }),
        // if character length greater then 2
        //filter((res) => res.length > 2),
        // Time in milliseconds between key events
        debounceTime(1000),
        // If previous query is diffent from current
        distinctUntilChanged()
        // subscription for response
      )
      .subscribe((text: string) => {
        this.carregando = true;
        this.atualizarFiltro([]);
      });

    fromEvent(this.filtroAno.nativeElement, 'keyup')
      .pipe(
        // get value
        map((event: any) => {
          return event.target.value;
        }),
        // if character length greater then 2
        //filter((res) => res.length > 2),
        // Time in milliseconds between key events
        debounceTime(1000),
        // If previous query is diffent from current
        distinctUntilChanged()
        // subscription for response
      )
      .subscribe((text: string) => {
        this.carregando = true;
        this.atualizarFiltro([]);
      });
    fromEvent(this.filtroDesc.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        //filter((res) => res.length > 2),
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.carregando = true;
        this.atualizarFiltro([]);
      });
    fromEvent(this.filtroOrig.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          return event.target.value;
        }),
        //filter((res) => res.length > 2),
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.carregando = true;
        this.atualizarFiltro([]);
      });
  }

  limpar(e) {
    e.value = '';
    this.atualizarFiltro([]);
  }

  atualizarFiltro(fitroInicial: Filtro[]) {
    this.carregando = true;
    this.dataSource = new MatTableDataSource<AtoPort>([]);

    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    let f: Filtro = new Filtro();
    let fA: Filtro[] = [];

    if (
      this.filtroNr.nativeElement.value &&
      this.filtroNr.nativeElement.value !== ''
    ) {
      f = new Filtro();
      f.chave = 'ATO-NR';
      f.id = this.filtroNr.nativeElement.value;
      fA.push(f);
    }
    if (
      this.filtroAno.nativeElement.value &&
      this.filtroAno.nativeElement.value !== ''
    ) {
      f = new Filtro();
      f.chave = 'ATO-ANO';
      f.id = this.filtroAno.nativeElement.value;
      fA.push(f);
    }
    if (
      this.filtroOrig.nativeElement.value &&
      this.filtroOrig.nativeElement.value !== ''
    ) {
      f = new Filtro();
      f.chave = 'ATO-ORIG';
      f.id = this.filtroOrig.nativeElement.value;
      fA.push(f);
    }
    if (
      this.filtroDesc.nativeElement.value &&
      this.filtroDesc.nativeElement.value !== ''
    ) {
      f = new Filtro();
      f.chave = 'ATO-DS';
      f.id = this.filtroDesc.nativeElement.value;
      fA.push(f);
    }
    f = new Filtro();
    f.chave = 'TIPODOC-ID';
    f.id = this.filtroTipoDocFixo;
    fA.push(f);
    if (fitroInicial) {
      fitroInicial.forEach((e) => {
        fA.push(e);
      });
    }
    //console.log('Filtros', fA);

    //filtro.chave = 'ATO-ANO';
    //filtro.id = '2019';
    //x.push(filtro);

    if (this.filtroTipoDocFixo != null) {
      this.dataSource$ = this.service.listarAtoPort(fA).pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),

        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
    } else {
      this.carregando = false;
    }
  }

  executarAoCarregarDatasourcePublicacoes(pp: PublicaPort[]) {
    //console.log('resultado  PublicaPort', pp);
    this.listaPublicaPort = pp;
    //console.log('lista', this.listaPublicaPort);
    this.dataSourcePP = new MatTableDataSource<PublicaPort>(pp);

    this.carregando = false;
  }

  //solicitei direito de acesso para o usuario meuportal nas tabelas de materia e publicacoes
  executarAoCarregarDatasource(x: AtoPort[]) {
    this.dataSource = new MatTableDataSource<AtoPort>(x);

    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = this.sortingDataAccessor;
    }
    this.carregando = false;
  }

  sortingDataAccessor(item, property) {
    if (property.includes('.')) {
      return property.split('.').reduce((object, key) => object[key], item);
    }
    return item[property];
  }

  dataEhPassada(d): boolean {
    return Util.dataEhValida(new Date(), new Date(d));
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }

    let f: Filtro = new Filtro();
    let fA: Filtro[] = [];
    f.chave = 'ATO-ANO';
    f.id = '2020';
    fA.push(f);

    this.atualizarFiltro(fA);

    /*
    let filtro: Filtro = new Filtro();
    let x: Filtro[] = [];

    filtro.chave = 'TIPODOC-ID';
    filtro.id = this.filtroTipoDocFixo;
    x.push(filtro);

    filtro.chave = 'ATO-ANO';
    filtro.id = '2019';
    this.filtroAno.nativeElement.value = '2019';
    x.push(filtro);

    this.dataSource$ = this.service.listarAtoPort(x).pipe(
      tap((a) => this.executarAoCarregarDatasource(a)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return EMPTY;
      })
    );* */
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }
  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  alterarLoading() {
    this.carregando = !this.carregando;
  }

  handleError(e) {
    this.erros$.next(true);
    this.carregando = false;
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
